import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fd0bdea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-listing-page" }

import { computed } from 'vue'
import { WPatientSidebar } from '@/widgets/WPatientSidebar'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const isPreviewMode = computed(() => route.query['view-mode'] === '1')

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isPreviewMode))
      ? (_openBlock(), _createBlock(_unref(WPatientSidebar), { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}
}

})